import { render } from "./WalletDialog.vue?vue&type=template&id=0eb021cb&scoped=true"
import script from "./WalletDialog.vue?vue&type=script&lang=js"
export * from "./WalletDialog.vue?vue&type=script&lang=js"

import "./WalletDialog.vue?vue&type=style&index=0&id=0eb021cb&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb021cb"]])

export default __exports__